<template>
    <div>
        <v-client-table :url="`/email-alerts/list?asset_type=${assetType}`" :columns="columns" :options="options" :data="alerts">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                    <router-link :to="`/email-alerts/create?asset_type=${assetType}`" class="btn btn-success"><i class="fa fa-plus"></i> Add</router-link>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="id" slot-scope="props">
                <router-link  :to="`/email-alerts/edit/${props.row.id}?asset_type=${assetType}`" title="Edit Email Alert" class="btn btn-sm btn-default">
                    <i class="fa fa-edit"></i>
                </router-link>
                <router-link :to="`/email-alerts/delete/${props.row.id}`" title="Delete Email Alert" class="btn btn-sm btn-default">
                    <i class="fa fa-trash text-danger"></i>
                </router-link>
            </template>

            <!-- <router-link slot="alert_name" slot-scope="props" :to="`/email-alerts/view/${props.row.id}`" title="View Email Alert">
                {{ props.row.alert_name }}
            </router-link> -->

            <template slot="is_active" slot-scope="props">
                <label v-if="props.row.is_active == 1" class="badge badge-success">Active</label>
                <label v-if="props.row.is_active == 0" class="badge badge-warning">Inactive</label>
            </template>

            <template slot="child_row" slot-scope="props">
                <div class="row" style="margin-right: -0.625rem; margin-left: -0.625rem;">
                    <div class="col-md-4 col-12 mb-md-0 mb-3">
                        <span class="font-weight-bold">Conditions</span><br>
                        WHEN:
                        <ol>
                            <li v-for="(cond, key) in props.row.conditions">
                                <template v-if="key > 0">AND:</template>
                                {{ cond.field_label }} {{ cond.logic == 'Equals' ? '=' : cond.logic }} {{ cond.cond_label }}
                            </li>
                        </ol>
                    </div>
                    <div class="col-md-6 col-12 mb-md-0 mb-3">
                        <span class="font-weight-bold">Recipients</span><br>
                        Send Email To:
                        <ol>
                            <li v-for="(recip, key) in props.row.recipients">
                                {{ recip.target_type }} -
                                <template v-if="recip.target_type == 'Employee' || recip.target_type == 'User'">
                                    {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}
                                </template>
                                <template v-else>{{ recip.target_label }}</template>
                            </li>
                        </ol>
                    </div>
                </div>
            </template>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        props: {
            assetType: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {
                alerts: [],
                columns: ['id', 'alert_name', 'is_active', 'description'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        alert_name: 'Name',
                        is_active: 'Status',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'email_alerts.id',
                    },
                },
            }
        },

        computed: {

        },

        methods: {
            //Load up
            getAlerts(){
                //Send it
                this.$http
                    .get('/email-alerts/list', {asset_type: this.assetType})
                    .then(response => {
                        //Set all the data
                        this.alerts = response.data.alerts;
                    })
                    .catch(response => {
                        //Set
                    })
                    .then(() => {

                    });
            },
        },

        mounted() {
            //Get the Alerts
            this.getAlerts();
        }
    }
</script>